'use client';

import { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { navItems } from './data/navItems';
import { useAuth } from './contexts/AuthContext';
import { useSelector } from 'react-redux';
import Sidebar from './components/Sidebar';
import Header from './components/Header';

const Layout = ({ title, description }) => {
	const [sidebarOpen, setSidebarOpen] = useState(false);
	const location = useLocation();
	const { logoutUser } = useAuth();
	const userData = useSelector((state) => state.user);

	const getRouteTitle = (path) => {
		const matchedNavItem = navItems.find(
			(item) => path === item.to || path.startsWith(item.to),
		);
		return matchedNavItem ? `Manage your ${matchedNavItem.title}` : null;
	};

	const defaultTitle = (() => {
		const routeTitle = getRouteTitle(location.pathname);

		if (location.pathname === '/' || location.pathname === '/dashboard') {
			return `Hey ${userData?.name || 'User'} 👋`;
		}

		return routeTitle || `Hey ${userData?.name || 'User'} 👋`;
	})();

	return (
		<div className='flex h-screen bg-gray-50'>
			{/* Sidebar */}
			<Sidebar
				open={sidebarOpen}
				setOpen={setSidebarOpen}
				logout={logoutUser}
				user={userData}
			/>

			{/* Main content */}
			<main className='flex-1 overflow-hidden h-screen flex flex-col'>
				<Helmet>
					<title>
						{title || defaultTitle} | Institution Dashboard
					</title>
					<meta
						name='description'
						content={
							description ||
							`${
								title || defaultTitle
							} - Dashboard Overview and Management`
						}
					/>
				</Helmet>

				<Header setSidebarOpen={setSidebarOpen} />

				<div className='flex-1 overflow-auto no-scrollbar'>
					<div className='m-6'>
						<Outlet context={{ user: userData }} />
					</div>
				</div>
			</main>
		</div>
	);
};

export default Layout;
